import { useCallback } from 'react'
import { createFileRoute, useLocation } from '@tanstack/react-router'
import { AccountPage, type AccountLocation } from '@/features/account/account-page'
import { parseAccountSearch } from '@/features/account/account-model'

export const Route = createFileRoute('/_console/account')({ validateSearch: parseAccountSearch, component: AccountRoute })
function AccountRoute() {
  const search = Route.useSearch()
  const hash = useLocation({ select: location => location.hash })
  const navigate = Route.useNavigate()
  const changeLocation = useCallback((next: AccountLocation) => {
    void navigate({ to: '/account', hash: next.tab, search: { ...(search.locale ? { locale: search.locale } : {}), ...(next.deviceId ? { device: next.deviceId } : {}) }, replace: true })
  }, [navigate, search.locale])
  return <AccountPage hash={hash} deviceId={search.device} hasLifecycleRetry={search.lifecycleRetry !== undefined} onLocationChange={changeLocation} onSignedOut={async () => { await navigate({ to: '/login', replace: true }) }} />
}
